import { Model } from "@vuex-orm/core";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export class GenexSISModel extends Model {

}
